import * as actionTypes from "../actions";

const initialState = {
  ela: [],
  ela_error: null
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_APP_TOKEN:
      return { ...state, ela: action.payload };

    case actionTypes.SET_APP_ERROR:
      return { ...state, ela_error: action.payload };

    default:
      return state;
  }
};

export default reducer;
